import {useQueryClient} from '@tanstack/react-query'

import {materialsQueryOptions} from './materialsQueryOptions'

export const usePrefetchMaterials = (plantCode: string) => {
  const queryClient = useQueryClient()
  void queryClient.prefetchQuery(materialsQueryOptions(plantCode))
}
